import React from 'react';
import type { LucideIcon } from 'lucide-react';

export type PageHeaderProps = {
  icon: LucideIcon;
  title: string;
  description?: string;
  actions?: React.ReactNode;
};

/** Dashboard / ürün sayfalarında tutarlı başlık düzeni */
const PageHeader: React.FC<PageHeaderProps> = ({ icon: Icon, title, description, actions }) => {
  return (
    <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3 min-w-0">
        <Icon className="w-8 h-8 shrink-0 text-purple-400 mt-0.5" aria-hidden />
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-white leading-tight">{title}</h1>
          {description ? <p className="text-gray-400 text-sm mt-1">{description}</p> : null}
        </div>
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto sm:justify-end">
          {actions}
        </div>
      ) : null}
    </header>
  );
};

/** Birincil sayfa aksiyon butonu stili */
export const pageHeaderPrimaryButtonClass =
  'inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg font-semibold transition transform hover:scale-105 w-full sm:w-auto';

export default PageHeader;
